import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { MembershipOpsPage } from "@/features/membership-ops";
import { membershipRouteSearchSchema } from "@/features/membership-ops/membership-route-search";

export const Route = createFileRoute("/memberships/")({
  validateSearch: membershipRouteSearchSchema,
  component: MembershipsRoute,
});

function MembershipsRoute() {
  return (
    <AdminDashboardShell>
      <MembershipOpsPage />
    </AdminDashboardShell>
  );
}
